/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/
define([
  "client/template",
  "client/templatetree",
  "client/templateregistry",
  "backbone",
  "api/v2/common",
  "component!base",
  "model/properties",
  "utils/trace",
  "utils/browser",
  "api/v2/search",
  "i18n/i18n",
  "!!raw-loader!../mustache/template.mustache",
  "jquery",
  "underscore",
  "utils/app",
  "utils/string",
  "utils/dom",
  "utils/jsonpath",
  "utils/resizer"
], function (
  Template,
  TemplateTree,
  TemplateRegistry,
  Backbone,
  Common,
  ComponentBase,
  PropertiesModel,
  Trace,
  Browser,
  Search,
  i18n,
  DEFAULT_TEMPLATE,
  $,
  _,
  AppUtils,
  StringUtils,
  dom,
  JSONPath,
  Resizer
) {

  var PreviewTemplate = Template.extend({
    editableName: "editor_preview_title",

    schema: new Template.Schema({
      id: "mb_preview",
      inputAttributes: {
        view: {
          type: "reference",
          reference: "view"
        },
      },
      // this will be lose end if presented in designer (no config is used at the moment) 
      attributes: {
        //   "completehtml": {
        //     type: "boolean",
        //     title: "editor_preview_completehtml",
        //     required: false
        //   },
        //   "enablePdfjs": {
        //     type: "boolean",
        //     title: "editor_preview_enable_pdfjs",
        //     "default": true,
        //     defaultValue: true
        //   },
        height: {
          type: "string",
          title: "editor_chat_height",
          default: "auto",
          visible: false,//FIXME: can be adjusted 
          values: [
            { value: "auto", text: i18n("editor_chat_automatic_view") },
            { value: "95vh", text: i18n("editor_chat_full_view") },
            { value: "75vh", text: i18n("editor_chat_third_view") },
            { value: "50vh", text: i18n("editor_chat_half_view") },
            { value: "25vh", text: i18n("editor_chat_quarter_view") }
          ]
        },
        standalone: {
          type: "boolean",
          title: "editor_preview_standalone",
          default: false,
          visible: false
        },
        contentHighlightRegions : {
          type: "JsonInput",
          visible: false, // it does not work well in designer
          title: "exprimental_highlighted_answer"
        }
      },
      // inputAttributes: {
      //   "location": {
      //     title: "location"
      //   },
      //   "full_html": {
      //     type: "boolean",
      //     title: "editor_preview_full_html",
      //     required: false
      //   }
      // },
    }),


    //we need this to be able to merge property via initAction
    getOptions: function(options) {
      this.useCamelCaseNames = true;
      // @todo the merge process in initActions need the properties here
      // @workaround this.get() returns the attribute model as an object
      // options should be string so the parseAttributes will chnage them to object if needed
      var attrs = this.get();
      var newAtts = {};
      if (attrs.contentHighlightRegions) {
        newAtts.contentHighlightRegions = attrs.contentHighlightRegions;
      }

      if (attrs.previewOffsets) {
        newAtts.previewOffsets = attrs.previewOffsets;
      }

      options = _.extend(
        {},
        Template.prototype.getOptions.apply(this, arguments),
        this.attributeModel.getCamelCase(),
        newAtts
      );
      return this.schema.parseAttributes(options);
    },

    getDefaultTemplate: function () {
      return DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;
    },

    hasContent: function () { return true; },
    getContentSchema: function () {
      return {
        type: "template"
      };
    },

    getContent: function () { return this.children[0].template; },

// **Conditional Rendering for Preview Modal:**

// This code block handles the behavior of the preview modal in the context of the `standalone` attribute and its potential impact on the client application.

// **Issue:**
// - When the `el` element is conditionally set to `undefined` based on the `standalone` attribute value, it leads to a discrepancy between the designer's behavior and the client app's functionality.

// **Client App Behavior:**
// - The initial preview click correctly appends the preview content to the modal stack.
// - However, closing the modal triggers the removal of the preview template from `index.html`.
// - This removal causes subsequent preview attempts to fail because the expected template is missing.

// **Model and `createView` Method:**
// - The model captures the `data-template` attribute value as "preview" and pushes it to the stack.

// **Potential Causes:**
// - The `createView` method in `application.js` might not be handling the "preview" template case correctly after the initial removal from `index.html`.

// **Recommended Approach:** see the application.js -> preview: function(){}

    createView: function (options) {
      var attributeExtention = _.extend({}, !options.application.editing && this.getOptions(),
      {
        application: options.application,
        template: this,
        el: this.attributeModel.get("standalone") ? this.el : undefined,
        resultTemplate: options.node.children[0].template
        // preview in standalone mode can not merge the property in designer due to getOptions call
      }); 
      var view = new PreviewView(_.extend({}, this.attributeModel.get(), options, attributeExtention));
      this.instances.push(view);
      return view;
    },

    remove: function (options) {
      $(this.el).empty();
      _.forEach(this.instances, function (view) {
        view.remove();
      });
      this.instances = [];
      _.forEach(options.node.children, function (childNode) {
        childNode.template.remove({
          node: childNode
        });
      });
    },

  });

  var PreviewView = ComponentBase.extend({
    initialize: function (args) {
      this.api = this.options.application.api;
      ComponentBase.prototype.initialize.apply(this, _.toArray(arguments));
      var rootEls = this.options.application.rootEls;
      var rootEl = AppUtils.getRootElement(rootEls, this.el);
      var viewportElement = this.options.application.options.viewportElement || rootEl;
      this.resizer = new Resizer(this.el, viewportElement, { height: this.options.height });
      this.resizeCallback = _.bind(this.resize, this);
      $(window).on("resize", this.resizeCallback);
      this.el.setAttribute("data-height", "auto");
      var isStandalonePreview = this.options.standalone;
      this.resultCollectionForPreview = new Search.ResultCollection({ "actions": { format: "PROPERTY" } });
      if (isStandalonePreview) {
        this.listenTo(this.resultCollectionForPreview, 'batchupdate', this.resultsChange.bind(this));
        this.model.addResultCollection(this.resultCollectionForPreview, { silent: true });
      } else {
        this.model = this.api.preview.createOutput();
      }
    },

    resultsChange: function (coll) {
      var actions;
      var model;
      try {
        model = coll.models.at(0);
        actions = model.get("actions", { format: "PROPERTY" });
        if (actions && !Array.isArray(actions)) {
          actions = [ actions ];
        }
      } catch (e) {
        console.log("no action found!")
      }
      if (!actions) { return; }
      for (var i = 0; i < actions.length; i++) {
        var action = actions[i];
        if (action.id === "Preview") {
          var model = coll.models.at(0);
          var preview = action.data[0].value.action.preview
          this.render(_.extend({}, model, preview));
          return;
        }
      }
    },

    render: function (options) {
      var actionName = "innerPreview";
      if (options && options.content_location) {
        actionName = "innerContentPreview";
      }
      if (actionName === "innerPreview") {
        this.innerPreview(options);
        return;
      }
      this.innerContentPreview(options)
    },

    remove: function () {
      if (this.messageCallbackPDFListener) {
        window.removeEventListener("message", this.messageCallbackPDFListener, false);
        this.messageCallbackPDFListener = null;
      }

      if (this.messageCallbackInitPDF) {
        window.removeEventListener("message", this.messageCallbackInitPDF, false);
        this.messageCallbackInitPDF = null;
      }

      $(window).off("resize", this.resizeCallback);
      Trace.enableHTML5Screenshot(this.html5ScreenshotWasEnabled);
      if (this.autoHeightResize) {
        this.autoHeightResize.destroy();
      } 
      return ComponentBase.prototype.remove.apply(this, arguments);
    },

    clear: function () {
      this.el.innerHTML = "";
    },

    getDisplayedProperties: function () {
      var properties = _.extend({}, this.options.resultTemplate.properties);
      delete properties["."];
      return properties;
    },

    pageY: function (elem) {
      return elem.offsetParent ? (elem.offsetTop + this.pageY(elem.offsetParent)) : elem.offsetTop;
    },

    resizeToBottom: function (elem, buffer) {
      var height = elem.ownerDocument.documentElement.clientHeight;
      height -= this.pageY(elem) + buffer;
      height = Math.max(height ,0);
      elem.style.height = height + 'px';
    },

    resize: function () {
      var el = $(this.el).find(".mb-previewcontent").get(0);
      if (el) {
        var resizeOffset = 90;
        if (this.options.standalone) {
          this.resizer.resize();
          return this
        }
        this.resizeToBottom(el, resizeOffset);
      }

      return this;
    },

    getUrl: function (preview) {
      var url = "" + preview.content_location;

        if (  preview.query_expr &&  (!preview.contentHighlightRegions || !preview.contentHighlightRegions.regions || !preview.contentHighlightRegions.regions.length)){
        try {
          var query = Search.SearchRequest.jsonifyQueryExpr(preview.query_expr);
          var queryStr = JSON.stringify(query);
          var queryParam = encodeURIComponent(queryStr);
          if (queryParam) {
            url += "&queryjsonv2=" + queryParam;
          }
        } catch (e) {
          if (console && console.warn) console.warn("Failed to process query expr:", preview.query_expr, e);
        }
      }

      url += "&itemdatajsonv2=" + encodeURIComponent(JSON.stringify({ collections: ["testing"] }));


      // Add a Loading Message if exists
      if (this.options.loadingMessage) {
        url += "&loadingMessage=" + encodeURIComponent(this.options.loadingMessage);
      }

      // Add LoadingMessage Styles if exists
      if (this.options.loadingMessageStyles) {
        url += "&loadingMessageStyles=" + encodeURIComponent(this.options.loadingMessageStyles);
      }

      // Add entity recognition options
      if (preview.markedEntities) {
        url += '&' + preview.markedEntities;
      }

      // add answers position to url params
      if(preview.contentHighlightRegions){
        try {
          var answersPositionStringify = JSON.stringify(preview.contentHighlightRegions);
          var answersPositionParam = encodeURIComponent(answersPositionStringify);
          if (answersPositionParam) {
            url += "&highlight_textregions_jsonv2=" + answersPositionParam;
          }
        } catch (e) {
          if (console && console.warn) console.warn("Failed to process answers position:", preview.answersPostion, e);
        }
      }

      url += '&deferredOpen=true';

      return url;
    },

    getContentPositionPage: function (preview) {
      return preview.contentPositionPage;
    },

    removeMessageEventListeners: function () {
      _.each(this.windowMessageListeners, function (handler) {
        window.removeEventListener("message", handler, false);
      });
      this.windowMessageListeners = [];
    },

    addMessageEventListeners: function () {
      _.each(this.windowMessageListeners, function (handler) {
        window.addEventListener("message", handler, false);
      });
    },

    pdfJsListener: function (preview, application) {
      var that = this;

      var messageCallbackPDFListener = function (e) {
        var childFrames = that.el && that.el.getElementsByTagName("iframe");
        var frameEl = childFrames && childFrames.length && childFrames[0];
        if (_.isObject(e.data) && e.data.name && frameEl) {
          var targetInfo = $.extend(true, { sourceInfo: e.source, frameEl: frameEl }, e.data); // make deep copy of e.data
          var eventObj = {
            view: this,
            model: preview.model,
            application: that.options.application,
            targetInfo: targetInfo,
            annotationId: e.data.id
          };

          if (e.data.name == "pdfjsviewer:annotation:mouseover") {
            eventObj.eventName = "preview:annotation:mouseover",
              that.options.application.views.trigger("preview:annotation:mouseover", eventObj);
          } else if (e.data.name == "pdfjsviewer:annotation:mouseleave") {
            eventObj.eventName = "preview:annotation:mouseleave",
              that.options.application.views.trigger("preview:annotation:mouseleave", eventObj);
          } else if (e.data.name == "pdfjsviewer:annoation:click") {
            eventObj.eventName = "preview:annotation:click",
              that.options.application.views.trigger("preview:annotation:click", eventObj);
          } else if (e.data.name == "pdfjsviewer:annotation:textselected") {
            eventObj.eventName = "preview:text:selected",
              that.options.application.views.trigger("preview:text:selected", eventObj);
          } else if (e.data.name == "pdfjsviewerinit") {
            e.source.postMessage({
              name: "pdfjsviewersetuptransformers",
              annotationTransformer: encodeURI(that.getAnnotationTransformerCallback()),
              annotationTheme: JSON.stringify(that.applicationOptions.theme || {}),
            },
              "*"
            );

            if (
              that.applicationOptions &&
              that.applicationOptions.ajaxOptions &&
              that.applicationOptions.ajaxOptions.requestHeadersAsync &&
              _.isFunction(that.applicationOptions.ajaxOptions.requestHeadersAsync)
            ) {
              that.applicationOptions.ajaxOptions.requestHeadersAsync(that.url, function (error, headerData) {
                if (error) {
                  console.error(error.message || 'Failed to get headers');
                  return;
                }
                e.source.postMessage({ name: "openPDFPreviewLocation", args: that.getPDFViewerArgs(headerData) }, "*");
              });
            } else {
              var channel = that && that.channel;

              var getFirstChannel = function (app) {
                if (app && app.channels && app.channels.at(0)) {
                  return app.channels.at(0);
                }
                return null;
              }

              if (!channel && that.options && that.options.application) {
                channel = getFirstChannel(that.options.application) || getFirstChannel(that.options.application.parentApplication);
              }

              if (channel) {
                var channelHeaders = AppUtils.getRequestHeaders(that.applicationOptions, channel.get("url"));

                setTimeout(() => {
                  e.source.postMessage({ name: "openPDFPreviewLocation", args: that.getPDFViewerArgs(channelHeaders) }, "*");
                }, 0);
              }
            }
          }
        }
      };

      this.windowMessageListeners.push(messageCallbackPDFListener);
      this.addMessageEventListeners();

      var removeEventHandlers = function () {
        that.stopListening(application, "destroy", removeEventHandlers);
        that.removeMessageEventListeners();
      };

      that.listenTo(application, "destroy", removeEventHandlers);

      that.options.application.views.on("preview:text:annotations:change", function (eventObj) {
        $(".mb-previewcontent").get(0).contentWindow.postMessage(
          {
            "name": "pdfjsviewerannotationschange",
            "page": eventObj.page,
            "createOrUpdate": eventObj.createOrUpdate,
            "delete": eventObj["delete"]
          },
          "*"
        );
      });
    },

    getAnnotationTransformerCallback: function () {
      //@question do we have for answers position ein highlighting
      var that = this;

      var annotationTransformerCallback =
        this.options.application &&
        that.options.application.views &&
        that.options.application.views._events &&
        that.options.application.views._events["annotation:transform"];

      if (!annotationTransformerCallback) {
        annotationTransformerCallback = function (annObj, annotationTheming, Browser, i18n) {

          function getBorderColorForEntity(entity) {

            // get entity theming from application options
            if (annotationTheming &&
              annotationTheming.elements &&
              annotationTheming.elements.entities &&
              annotationTheming.elements.entities[entity] &&
              annotationTheming.elements.entities[entity]['background-color']) {
              return annotationTheming.elements.entities[entity]['background-color'];
            }

            switch (entity) {
              case 'person':
                return '#f44d61'; // red
              case 'organization':
                return '#8e7dff'; // purple
              case 'date':
                return '#2fbbab'; // green
              case 'misc':
                return '#bb702f'; // brown
              case 'location':
                return '#4d74f4'; // blue
              default:
                return '#5f6d99'; // darkblue
            }
          };

          // if is NER (entity recognition)
          if (annObj.href && annObj.href.match('prop-label')) {
            var entity = Browser.getURLParameterByString('prop-label', annObj.href);
            annObj.title = i18n('entity_' + entity);
            annObj.style = { "border-color": getBorderColorForEntity(entity) };

          } else if (annObj.href && annObj.href.match(/[&?]isnegation=true/)) {
            annObj.isEntity = true;
            annObj.style = { "border-color": "green" };
            annObj.title = "";
          }
          else {
            annObj.isEntity = true;
            annObj.style = { "color": "green" };
            annObj.title = "";
          }

          return annObj;
        }
      }

      return annotationTransformerCallback;
    },

    getPDFViewerArgs: function (channelHeaders) {
      return {
        source: this.url,
        contentPositionPage: this.contentPositionPage,
        highlightAnswerText: this.highlightAnswerText,
        pdfViewerArgs: {
          httpHeaders: channelHeaders,
          withCredentials: true
        }
      }
    },

    setHtmlPreview: function (application, html, options) {
      var options = options || {};
      var model = new PropertiesModel([],
        { propertyDefinitions: {} });
      var leave = Trace.events.uiRender.enter(options.traceContext && options.traceContext.context);

      try {
        if ($(this.el)) {
          $(this.$el).addClass("mb-in-preview");
        }

        if (model) {
          model.trigger("change");
        }
        this.removeOwnedNodes();


        var containerEl = this.make("div", { "class": "mb-html-preview-container" });
        $(containerEl).html(html);

        if (options && options.model && options.model.get("categoryclass") && _.isString(options.model.get("categoryclass"))) {
          $(containerEl).addClass(options.model.get("categoryclass"));
        }

        var previewEl = document.querySelector('[data-template="preview"]')


        $(previewEl).append(containerEl);

        containerEl.setAttribute("tabindex", "0");
        window.setTimeout(function () {
          containerEl.focus();
        }, 1);
      } finally {
        leave.leave();
      }
    },

    setContentPreview: function (application, preview, options) {
      try {
        var app =  application.options && ((application.options.application) || application || {});
        var contentHighlightRegionsSettings = app && ((app.parentApplication && app.parentApplication.options.contentHighlightRegionsSettings) || app.options.contentHighlightRegionsSettings);
        const HIGHLIGHT_STRATEGY = ["UNKNOWN" , "MARK_START_POS", "MARK_END_POS", "MARK_START_AND_END_POS", "HIGHLIGHT_TEXT"];
        const ENABLE_HIGHLIGHT_MULTIPLE_REGIONS = false;
  
        var highlightStrategy = contentHighlightRegionsSettings && contentHighlightRegionsSettings.highlightStrategy;
        highlightStrategy = (typeof highlightStrategy === "string" && HIGHLIGHT_STRATEGY.includes(highlightStrategy) && highlightStrategy);

        var clickedAnswerOutputModel = (preview && preview.model && preview.model.output) || {};
        var clickedAnswerMesKey = clickedAnswerOutputModel && _.isFunction(clickedAnswerOutputModel.get) && clickedAnswerOutputModel.get("mes:key");
        var searchModel = (application.parentApplication && application.parentApplication.models.search) || (application.models && application.models.search) || {};

        var contentHighlightRegionsOptions = {
          search: searchModel,
          preview: preview,
          clickedAnswerMesKey: clickedAnswerMesKey,
          enableHighlightMultiRegions: (contentHighlightRegionsSettings && contentHighlightRegionsSettings.highlightMultipleRegions) ||  ENABLE_HIGHLIGHT_MULTIPLE_REGIONS
        };
        var contentHighlightRegions = (this.options && this.options.contentHighlightRegions) || _.isFunction(this.getPreviewContentHighlightRegions) && this.getPreviewContentHighlightRegions(contentHighlightRegionsOptions);

        if (contentHighlightRegions) {
          try {
            var contentHighlightRegions = (typeof contentHighlightRegions === "string" && JSON.parse(contentHighlightRegions)) || contentHighlightRegions;
            // in frontend we defaulted the highlighting to `HIGHLIGHT_TEXT` but in common.proto it is still "MARK_START_AND_END_POS
            highlightStrategy && (contentHighlightRegions["strategy"] = highlightStrategy) || (contentHighlightRegions["strategy"] = HIGHLIGHT_STRATEGY[4]);
            preview.contentHighlightRegions = contentHighlightRegions;
          } catch (error) {
            console && console.log("Failed to use contentHighlightRegions for preview!");
          }
        }
      } catch (error) { // make sure new changes wont stop preview
        console && console.log("Failed to use contentHighlightRegions for preview!" , error);
      }

      this.channel = options.channel;
      this.applicationOptions = application.options;
      this.url = this.getUrl(preview);
      this.contentPositionPage = this.getContentPositionPage(preview);
      this.highlightAnswerText = preview.highlightAnswerText;

      if (this.parentView) {
        this.parentView.$el.addClass("mb-in-preview");
      }

      this.removeMessageEventListeners();
      var previewEl = $(this.el);

      //@todo this.el is container
      var containerElement = this.make("div", { "class": "mb-preview" });
      var previewElement = null;

      // don't use object, if we are in Mobile Safari
      if (preview.content_type === "application/pdf" && !/mobile.*safari/i.test(navigator.userAgent)) {
        previewElement = this.make("object", {
          "data": this.url,
          "class": "mb-previewcontent",
          "style": "width: 100%; height: 100%"
        });
      } else {
        previewElement = this.make("iframe", {
          "src": this.url,
          "class": "mb-previewcontent",
          "style": "width: 100%; height: 100%"
        });
        // In case of a standalone PDF views, the application is a view and the application instance is application.options.application,
        // for Preview it is an application instance 
        this.pdfJsListener(preview, app);
      }

      if (this.options.standalone) {
        $(this.el).children("[class*='mb-preview']").remove();
        var title = document.createElement("h2");
        // FIXME - The preview object in workplace has model property but not in standard client
        title.innerHTML = (preview.model && preview.model.get && preview.model.get("title", {
              format: "HTML"
            })) || (preview.get && preview.get("title", { format: "HTML" })) || "";
        title.classList.add('mb-preview-title');
        containerElement.append(title);
        this.el.append(containerElement);
        previewEl.append(this.el);
        previewEl.css("display", "flex");
        previewEl.css("flex-direction", "column");
        containerElement.style.height = "100%";
        containerElement.style.flexGrow = 1;
        containerElement.style.display = "flex";
        containerElement.style.flexDirection = "column";
      } else {
        this.removeOwnedNodes();
        this.appendChild(containerElement, true);
      }
      containerElement.append(previewElement);
      containerElement.setAttribute("tabindex", "0");
      window.setTimeout(function () {
        containerElement.focus();
      }, 1);
    },

    getPreviewContentHighlightRegions: function(options) {
      if(!options) return;
      var regionsObj = _.extend({ regions: [] }, {});
      if(options.preview.highlighting){
        var highlighting = options.preview.highlighting
         var startPos = highlighting.text_region.start_position;
            var endPos = highlighting.text_region.end_position || highlighting.text_region.start_position;
            if ((typeof startPos === 'number') && (typeof endPos === 'number')) {
              regionsObj.regions.push({ start: startPos, end: endPos });
            }
         return regionsObj;
      }
      
      var answers = options.search && options.search.output && _.isFunction(options.search.output.get) && options.search.output.get("answers");
      if (options.enableHighlightMultiRegions) {
        //filter answers related to preview document
        answers = _.filter(answers, function(answer) {
          var answerMesKey = answer && answer.properties && answer.properties["mes:key"] && answer.properties["mes:key"].data && answer.properties["mes:key"].data[0] && answer.properties["mes:key"].data[0].value;
          if (options.clickedAnswerMesKey && answerMesKey && options.clickedAnswerMesKey === answerMesKey) {
            return answer;
          }
        });
        _.forEach(answers, function(answer) {
          if (answer.text && answer.text.property_name === "content") {
            var startPos = answer.text.text_start_pos;
            var endPos = answer.text.text_end_pos || answer.text.text_start_pos;
            if ((typeof startPos === 'number') && (typeof endPos === 'number')) {
              regionsObj.regions.push({ start: startPos, end: endPos });
            }
          }
        });
      } else {
        if(!options.preview || !options.preview.model) return;
        const textRegion = options.preview.model.output.get("text");
        const isContent = options.preview.model.output.get("property_name") === "content";
        if (textRegion && isContent) {
          var startPos = textRegion.text_start_pos;
          var endPos = textRegion.text_end_pos || textRegion.text_start_pos;
          if ((typeof startPos === 'number') && (typeof endPos === 'number')) {
            regionsObj.regions.push({ start: startPos, end: endPos });
          }
        }
      }
      return regionsObj;
    },

    setPreview: function (application, model, options) {

      var that = this,

        // This section handles the behavior of the preview template in the client code.

        // 1. Initial Preview Display:
        //    - Upon first opening the preview, the preview template is displayed in the `index.html` file.

        // 2. Preview Removal:
        //    - When the preview is closed in the client, the preview template is removed from the DOM (Document Object Model) of `index.html`. This ensures a clean user experience by removing the preview content after it's no longer needed.
        //    - This only happen when this.createView use this.el in the options
        // 3. Potential Issue:
        //    - **Crucially, there's a potential issue:** If the `resultTemplate` is subsequently changed to `clientnotification` after the preview is closed, this could lead to unexpected behavior or errors. This is because the `clientnotification` template might not be compatible with the intended use case for the preview.

        view = this.options.resultTemplate.createView({ model: model, application: application });

      if (this.options.standalone) {
        this.$el.children("[class*='mb-preview']").remove();
        var title = document.createElement("h2");
        title.innerHTML = model.get("title", { format: "HTML" });
        title.classList.add('mb-preview-title');
        this.el.append(title);
        this.$el.append(view.el);
        $(this.el).append(this.$el)
        view.$el.attr("tabindex", "0");
        return;
      }
      options = options || {};

      var leave = Trace.events.uiRender.enter(options.traceContext && options.traceContext.context);

      try {
        var originalRemove = view.remove;
        if (this.parentView) {
          this.parentView.$el.addClass("mb-in-preview");
        }

        view.remove = function () {
          if (_.isFunction(originalRemove)) {
            originalRemove.apply(view, arguments);
          }
          if (that.parentView) {
            that.parentView.$el.removeClass("mb-in-preview");
          }
        };

        if (model) {
          model.trigger("change");
        }
        this.removeOwnedNodes();
        this.appendChild(view.el, true);

        view.$el.attr("tabindex", "0");
        window.setTimeout(function () {
          view.$el.focus();
          setTimeout(function () { window.scroll(0, 0); }, 1);
        }, 1);
      } finally {
        leave.leave();

      }
    },

    innerPreview: function (options, traceContext) {

      traceContext = traceContext && traceContext.willLeave();
      var that = this;

      this.getPreviewView(_.bind(function (previewView) {

        var model = options,
          channel = model.channel,
          location = model.get("location"),
          search = (this.options.application.models || this.options.application.options.application.models).search.input,
          query = search.get("user.query") || search.get("query");

        if (location) {
          var properties = JSONPath.get(model.output, location.split(","));
          if (!_.isEmpty(properties)) {
            location = that.getPropertyHTMLByValue("mes:location", properties);
          }
        }
        if (_.isBoolean(model.output.get("enable_char_ngrams")) && !_.isUndefined(query)) {
          query.enable_char_ngrams = model.output.get("enable_char_ngrams");
        }

        var propertyDefinitions = Common.mergePropertyDefinitions({
          title: { format: "HTML" },
          "mes:summary": { format: "PROPERTY" },
          content: { format: "HTML" },
          extension: { format: "HTML" },
          "html/head": { format: "HTML" },
          "categoryclass": { format: "HTML" },
          "@content": { format: "HTML" }
        }, previewView.getDisplayedProperties());

        if (options && !options.model) {
          options.model = options;
        }
        var inputOptions = {
          "location": location,
          category: options.category || options.model.get("category"),
          categoryinstance: options.categoryinstance || options.model.get("categoryinstance"),
          key: options.key,
          query_expr: query,
          full_html: true,                     /* capability for understanding full html */
          "properties": _.reduce(propertyDefinitions, function (defs, value, key) { defs[key] = { formats: [value.format] }; return defs; }, {})
        };

        this.setPreviewMarkedEntities(inputOptions);

        var application = (that.parentApplication || that);
        if (application.options.disableExternalContextualization) {
          inputOptions.disable_external_contextualization = true;
        }

        var previewInput = this.api.preview.createInput(inputOptions);
        var callback = function (response, error) {
          if (response &&
            response.attributes &&
            response.attributes["mindbreeze.internal.databytes.content_type"] &&
            response.attributes["mindbreeze.internal.databytes.content_type"] == "text/html" &&
            response.attributes.data) {
            previewView.setHtmlPreview(that, response.attributes.data, { traceContext: traceContext, model: options.model });

          } else {
            var model, title, result;

            if (response.get("result")) {
              result = response.submodel("result");
              model = new PropertiesModel(result.get("properties"), { propertyDefinitions: propertyDefinitions });
              title = that.getPreviewTitle(model),
                result.dispose();
            }

            previewView.setPreview(that, model, { traceContext: traceContext })
          }

          if (options.target) {
            options.target.appendChild(previewView.el);
          }
          if (title) {
            options.titleModel && options.titleModel.set("title", "<h2><small class='preview-small-title'>" + i18n("preview") + "</small> " + title + "</h2>");
          }

          traceContext && traceContext.leave();
        }

        this.api.preview.call(channel,
          previewInput.toJSON(),
          callback,
          {
            traceContext: traceContext
          }
        );
      }, that));
    },

    innerContentPreview: function (options, traceContext) {
      traceContext = traceContext && traceContext.willLeave();
      var that = this;

      this.getPreviewView(_.bind(function (previewView) {
        var model = options,
          channel = model.channel,
          title = this.getPreviewTitle(model),
          search = (this.options.application.models || this.options.application.options.application.models).search,//(this.parentApplication || this).models.search,
          query = search.get("user.query") || search.get("query"),
          contentPositionPage = model.get("mes:contentpositionpage"),
          highlightAnswerText = '';

        if (model.output.get("text") && model.output.get("text").text_start_page) {
          contentPositionPage = model.output.get("text").text_start_page;
          highlightAnswerText = model.output.get("text").text;
        }

        if (options.location_path) {
          var properties = JSONPath.get(model.output, options.location_path.split(","));
          if (!_.isEmpty(properties)) {
            title = that.getPropertyHTMLByValue("title", properties);
          }
        }

        var aclConstraint = this.getACLConstraint();
        if (aclConstraint) {
          if (!query || !query.and) {
            query = { and: { query: aclConstraint } }
          } else {
            query.and.aclConstraint = aclConstraint;
          }
        }

        if (_.isBoolean(model.output.get("enable_char_ngrams")) && !_.isUndefined(query)) {
          query.enable_char_ngrams = model.output.get("enable_char_ngrams");
        }

        var markedEntities = null;
        if (!_.isUndefined(this.options.entity)) {
          var markAllEntityTypes = this.options.entity.markAllEntityTypes;
          var markEntityTypes = this.options.entity.markEntityTypes;
          var isDisabled = this.entitiesAreDisabledForFeature('pdfPreview');

          try {
            if (isDisabled) {
              markedEntities = 'mark_all_entity_types=false';
            } else {
              // priorize all entities before explicit entities from the options
              if (!_.isUndefined(markAllEntityTypes)) {
                if (_.isUndefined(markEntityTypes)) {
                  // Wenn mark_all_entities is set without the rest, we want to set mark_all_entities
                  markedEntities = 'mark_all_entity_types=' + markAllEntityTypes;
                } else {
                  // When mark_all_entities is set and mark_entities is set, we want to set both as given
                  markedEntities = 'mark_all_entity_types=' + markAllEntityTypes + '&mark_entity_types=' + markEntityTypes.join(';');
                }
              } else if (!_.isUndefined(markEntityTypes)) {
                // When mark_entities is iset instead we want to set all_entities to false in addition
                markedEntities = 'mark_all_entity_types=false&mark_entity_types=' + markEntityTypes.join(';');
              }
            }
          } catch (e) {
            if (console && console.warn) console.warn("Failed to set marked entities", e);
          }
        }
        previewView.setContentPreview(
          that,
          _.extend({ query_expr: query, contentPositionPage: contentPositionPage, highlightAnswerText: highlightAnswerText, markedEntities: markedEntities }, options),
          { traceContext: traceContext, channel: channel }
        );

        if (options.target) {
          options.target.appendChild(previewView.el);
        }
        previewView.resize();

        if (title) {
          options.titleModel && options.titleModel.set("title", "<h2><small class='preview-small-title'>" + i18n("preview") + "</small> " + title + "</h2>");
        }

        traceContext && traceContext.leave();


      }, that));
    },

    getPreviewTitle: function (model) {
      return model.get("title", { format: "HTML" });
    },

    getPreviewView: function (callback) {
      var that = this;
      var templateTree = that.options.application.templateTree || that.options.application.options.application.templateTree;
      var template = templateTree.getTemplateById("mb_preview");

      if (template && template.instances && template.instances.length) { return callback(template.instances.instances[0]); }
      callback(that);
    },

    getPropertyHTMLByValue: function (value, properties) {
      try {
        return properties[value].data[0].html;
      } catch (e) {
        console.error("Can not read property " + value + ". The PDF preview will not work correctly. Please make sure that this property is requested as format html.")
        return value;
      }
    },

    entitiesAreDisabledForFeature: function (key) {
      if (this.options.entity.disabled && !_.isUndefined(this.options.entity.disabled[key])) {
        return this.options.entity.disabled[key];
      }
      return null;
    },

    setPreviewMarkedEntities: function (inputOptions) {
      if (this.options.entity) {
        this.setPreviewMarkedEntityOptions(inputOptions);

      } else {
        // legacy entity options
        this.setPreviewMarkedEntity('sampleTextMarkEntityTypes', inputOptions);
        this.setPreviewMarkedEntity('sampleTextMarkAllEntityTypes', inputOptions);
      }
    },

    setPreviewMarkedEntityOptions: function (options) {
      if (!_.isUndefined(this.options.entity)) {
        var markAllEntityTypes = this.options.entity.markAllEntityTypes;
        var markEntityTypes = this.options.entity.markEntityTypes;
        var isDisabled = this.entitiesAreDisabledForFeature('preview');

        if (isDisabled === true) {
          // When disabled, always set mark_all_entities to false
          options[StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes")] = false;
          return;
        }

        // priorize all entities before explicit entities from the options
        if (!_.isUndefined(markAllEntityTypes)) {
          if (_.isUndefined(markEntityTypes)) {
            // Wenn mark_all_entities is set without the rest, we want to set mark_all_entities
            options[StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes")] = markAllEntityTypes;

          } else {
            // When mark_all_entities is set and mark_entities is set, we want to set both as given
            options[StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes")] = markAllEntityTypes;
            options[StringUtils.camelCaseToSnakeCase("sampleTextMarkEntityTypes")] = markEntityTypes;

          }
        } else if (!_.isUndefined(markEntityTypes)) {
          // When mark_entities is iset instead we want to set all_entities to false in addition
          options[StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes")] = false;
          options[StringUtils.camelCaseToSnakeCase("sampleTextMarkEntityTypes")] = markEntityTypes;

        }

      }
    },

    setPreviewMarkedEntity: function (key, options) {
      var entityOptions = this.options.preview && this.options.preview[key];
      if (!_.isUndefined(entityOptions)) {
        var data = this.getEntityValue(entityOptions, key);
        options[StringUtils.camelCaseToSnakeCase(key)] = data;
      }
    },

    getACLConstraint: function () {
      return (this.options.application.channels || this.options.application.options.application.channels).getACLConstraint();
    },


  });

  PreviewTemplate.View = PreviewView;

  TemplateRegistry.add({
    id: "mb_preview",
    name: "editor_preview_title",
    weight: 10,
    getAdders: function (model) {
      return [
        {
          name: "editor_preview_title",
          icon: "../img/preview.png",
          group: {
            name: "Preview"
          },
          options: {
            template: 'preview',
            standalone: true,
            contentHighlightRegions:"",
            height: "auto"
          },
        },
      ]
    },

    create: function (options) {
      var schema = new Template.Schema();
      options = options || {};
      options.template = options.template;
      var el = document.createElement("div");
      el.classList.add("mb-editable")
      el.id = "mb_preview";

      _.forEach(options, function (value, key) {
        el.setAttribute("data-" + dom.AttributeModel.camelCaseToSeparated(key), schema.serializeAttribute(value, key));
      });

      return el;
    }
  });

  return PreviewTemplate;
});
